/**
 * Normalize LLM/editor output for ReactMarkdown (strip ```markdown fences, trim).
 */
export function normalizeMarkdownContent(text) {
  if (!text) return '';
  const trimmed = text.trim();
  const fullFence = /^```(?:markdown|md)?\s*\n([\s\S]*?)\n```\s*$/i.exec(trimmed);
  if (fullFence) return fullFence[1].trim();
  if (/^```(?:markdown|md)?\s*\n/i.test(trimmed) && trimmed.endsWith('```')) {
    return trimmed
      .replace(/^```(?:markdown|md)?\s*\n/i, '')
      .replace(/\n```\s*$/, '')
      .trim();
  }
  return trimmed;
}
